import React from 'react';
import EstimateForm from '@/components/estimates/EstimateForm';

const CreateEstimatePage = () => {
  // EstimateForm already uses PageLayout internally, no extra wrapper needed
  return <EstimateForm />;
};

export default CreateEstimatePage;
